import { colorsPalettes } from "@similarweb/styles";
import dayjs from "dayjs";

const normalizeChartXData = (value) => {
    const date = new Date(value);

    if (date.toString() !== "Invalid Date") {
        return dayjs.utc(value).unix() * 1000;
    }

    return value;
};

export const generateColumnChartData = (chartTitles, dataSeries) => {
    return [
        {
            name: chartTitles[0],
            color: colorsPalettes.orange[400],
            data: dataSeries.map((item) => ({
                name: normalizeChartXData(item.Values[1].Key),
                y: item.Values[1].Value,
                change: item.Change,
            })),
        },
        {
            name: chartTitles[0],
            color: colorsPalettes.blue[400],
            data: dataSeries.map((item) => ({
                name: normalizeChartXData(item.Values[0].Key),
                y: item.Values[0].Value,
                change: item.Change,
            })),
        },
    ];
};
